import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from './../shared/shared.module';
import { HeaderShellComponent } from './header-shell.component';
import { HeaderUserInfoComponent } from './header-user-info/header-user-info.component';
import { HeaderComponent } from './header/header.component';
import { LanguageDropdownComponent } from './language-dropdown/language-dropdown.component';

@NgModule({
  declarations: [
    HeaderUserInfoComponent,
    HeaderComponent,
    HeaderShellComponent,
    LanguageDropdownComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    TranslateModule.forChild()
  ],
  exports: [
    HeaderShellComponent
  ]
})
export class HeaderShellModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: HeaderShellModule
    };
  }
}
